function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", {
  id: "questionsTitle"
}, "questions");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M42.167 22c2.393 0 4.333 2.015 4.333 4.5v2.25h2.167c2.393 0 4.333 2.015 4.333 4.5V58H27V22zm-2.908 23.206c-.673 0-1.24.219-1.703.655-.462.437-.694 1.005-.694 1.703 0 .699.232 1.266.694 1.702.462.438 1.03.655 1.703.655.694 0 1.272-.217 1.734-.655.462-.436.694-1.003.694-1.702 0-.698-.232-1.266-.694-1.703-.462-.436-1.04-.655-1.734-.655zm.851-15.128c-1.954 0-3.463.448-4.524 1.343-1.062.895-1.761 2.15-2.097 3.766l3.468 1.276c.231-2.007 1.199-3.012 2.901-3.012.799 0 1.445.235 1.94.704.493.47.74 1.184.74 2.145 0 1.178-.305 2.003-.914 2.472-.61.47-1.482.704-2.617.704h-1.388v4.388h3.28v-2.227c.651-.021 1.313-.13 1.986-.327s1.277-.513 1.813-.95c.536-.436.972-1.01 1.309-1.719.336-.709.504-1.588.504-2.636 0-.873-.153-1.675-.457-2.407-.305-.73-.74-1.358-1.309-1.882-.567-.524-1.245-.928-2.033-1.212-.789-.283-1.655-.426-2.602-.426zM53 22v4.5L48.667 22H53z",
  transform: "translate(-529 -650) translate(529 650)"
}))));

var SvgPrimaryButtonUiQuestionsIcon = function SvgPrimaryButtonUiQuestionsIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    "aria-labelledby": "questionsTitle",
    role: "img",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", {
    id: "questionsTitle"
  }, title) : null, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPrimaryButtonUiQuestionsIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/primary-button-ui-questions-icon.ccc24449.svg";
export { ForwardRef as ReactComponent };